var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { usePayment } from "../../app/usePayment";
export var PAY_BUTTON_TEXT_FALLBACK = "Purchase";
export var VAULT_BUTTON_TEXT_FALLBACK = "Save for future use";
export var PayButton = function (_a) {
    var disabled = _a.disabled, _b = _a.fullWidth, fullWidth = _b === void 0 ? true : _b, _c = _a.buttonText, buttonText = _c === void 0 ? PAY_BUTTON_TEXT_FALLBACK : _c;
    var handleGetClientToken = usePayment().handleGetClientToken;
    return (_jsx("button", __assign({ className: classNames({
            "justify-center align-center rounded-md px-4 py-2 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-blue-500 text-white bg-blue-500 hover:bg-blue-600  shadow-sm": true,
            "w-full": fullWidth,
        }), onClick: function () { return handleGetClientToken(); }, disabled: disabled }, { children: buttonText })));
};
